import { React } from "mondrian-react";
import Footer from "components/Footer";
import Loading from "components/Loading";
import Topbar from "components/Topbar";
import AccessbilityBar from "components/AccessibilityBar";
import AlertPWA from "components/AlertPWA";
import useIsTotem from "hooks/useIsTotem";
import useIsPJ from "hooks/useIsPJ";
import AdCarrossel from "components/BannerGoogleAdManager";
import { WebPushNotification } from "components/WebpushAlert";

const PageContainer = ({ children, isLoading }) => {
  const isTotem = useIsTotem();
  const isPJ = useIsPJ();

  return (
    <>
      {!isTotem && (
        <>
          <Topbar />
          <AccessbilityBar />

          {!isPJ && (
            <AdCarrossel
              conta={22212599076}
              canal="mcm_web_faturafacil_nl_movel_tp_cr"
              larguraDesktop={970}
              alturaDesktop={250}
              larguraCelular={336}
              alturaCelular={280}
              breakPoint={639}
              totalSlides={10}
            />
          )}
        </>
      )}

      {/iPad|iPhone|iPod/.test(window?.navigator?.userAgent) ||
      isTotem ||
      isPJ ? null : (
        <AlertPWA />
      )}

      {isPJ && (
        <>
          <WebPushNotification />
          <AdCarrossel
            conta={22212599076}
            canal="mce_web_faturafacil_nl_home_tp_cr"
            larguraDesktop={970}
            alturaDesktop={250}
            larguraCelular={336}
            alturaCelular={280}
            breakPoint={639}
            totalSlides={10}
          />
        </>
      )}

      <main id="content" className={"mdn-Container"}>
        {isLoading ? <Loading /> : children && children}
      </main>

      {!isTotem && <Footer />}
    </>
  );
};

export default PageContainer;
